import { render } from "./RaceReligion.vue?vue&type=template&id=62e15f7d"
import script from "./RaceReligion.vue?vue&type=script&lang=js"
export * from "./RaceReligion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__